import React from 'react';
import { Container } from 'reactstrap';
import PropTypes from 'prop-types';
import { HOST_URL, PlatformDataForIntegrationPage } from '../../constants/globals';

function getParameter(locationURL, desiredParameter) {
  const substring = locationURL.split('?')[1];
  const parameters = substring.split('&');
  for (let i = 0; i < parameters.length; i += 1) {
    if (parameters[i].includes(`${desiredParameter}=`)) return parameters[i].substring(parameters[i].indexOf('=') + 1);
  }
  return null;
}

async function integrate(urlID, code) {
  try {
    const response = await fetch(`${HOST_URL}/api/integration/${urlID}/redirect/${code}`);
    return await response.json();
  } catch (error) {
    console.log('error');
    return error;
  }
}

class RedirectPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      urlID: props.match.params.urlID,
      platform: PlatformDataForIntegrationPage[props.match.params.urlID],
      location: props.location,
      integrationInProgress: true,
      integrated: false,
    };
  }

  componentDidMount() {
    const { urlID, platform, location } = this.state;
    const response = integrate(urlID, getParameter(location.search, 'code'))
      .then(
        (e) => {
          this.setState({ integrationInProgress: false });
          if (e.success) {
            this.setState({ integrated: true });
          }
        },
      );
  }


  render() {
    const {
      urlID, platform, integrationInProgress, integrated,
    } = this.state;

    function integrationStatus() {
      if (integrationInProgress) {
        return 'Integration In Progress...';
      }
      if (integrated) {
        return 'Integrated Successfully!';
      }
      return 'Integration Failed.';
    }

    return (
      <Container>
        <h1>{platform.fullName}</h1>
        <h2>{integrationStatus()}</h2>
      </Container>
    );
  }
}

RedirectPage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
};
export default RedirectPage;
